import React from 'react';
import { render } from 'react-dom';
import Spinner from '@narvar/nth-spinner';
import ReturnsSidebar from '../../react-components/ReturnsSidebar/ReturnsSidebar';
import SchedulePanel from './components/SchedulePanel';
import PickupLocationPanel from './components/PickupLocationPanel';
import { store } from '../../store';

export const renderScheduledPickup = ({
  actions,
  pickupState,
  handlers,
  node,
}) => {
  const {
    language,
    retailerSettings: { branding: { brand_call_to_action: brandCTAColor } = {} } = {},
  } = store.getState();

  const {
    panel,
    businessAddress,
    showError,
    config: { return_carrier: carrierMoniker } = {},
    currentData: {
      editAddressData = {},
      scheduleData: { pickup_date: pickupDate = '' } = {},
      pickupData: { pickup_dates: pickupDates = [] } = {},
      pickupDetails = [],
    } = {},
  } = pickupState;
  const selectedPickupDate = new Date(pickupDate);
  const mappedPickupDates = pickupDates.map(
    ({ pickup_date: date }) => new Date(date.split('-').join('/')),
  );

  render(
    <ReturnsSidebar
      title={language[`returns.step_2.pickup_${carrierMoniker}.sidebar.title`]}
      toggleSide="right"
      sidebarOpen={pickupState.open}
      backIconOnClick={panel === 1 ? actions.changePanel : () => {}}
      closeIconOnClick={actions.close}
      overlayOnClick={actions.close}
    >
      {pickupState.loading ? (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <Spinner style={{ width: '4em' }} />
        </div>
      ) : (
        <div style={{ textAlign: 'left' }}>
          {panel === 0 ? (
            <SchedulePanel
              ctaColor={brandCTAColor}
              showError={showError}
              pickupDates={mappedPickupDates}
              handleDaySelect={actions.saveDate}
              selectedPickupDate={selectedPickupDate}
              pickupLocationDetails={pickupDetails}
              buttonDisabled={!handlers.checkRequiredInputs()}
              buttonOnClick={handlers.confirmPickupDetails}
              pickupLocationLabel={
                language[`returns.step_2.pickup_${carrierMoniker}.sidebar.pickup_location_title`]
              }
              pickupLocationSubtitle={
                language[`returns.step_2.pickup_${carrierMoniker}.sidebar.pickup_location_subtitle`]
              }
              errorMessage={
                language[`returns.step_2.pickup_${carrierMoniker}.sidebar.pickup_error`]
              }
              datePickerLabel={
                language[`returns.step_2.pickup_${carrierMoniker}.sidebar.date_picker_label`]
              }
              datePickerSubtitle={
                language[`returns.step_2.pickup_${carrierMoniker}.sidebar.date_picker_subtitle`]
              }
              buttonText={language[`returns.step_2.pickup_${carrierMoniker}.sidebar.submit_label`]}
            />
          ) : (
            <PickupLocationPanel
              handleFormChange={actions.handleFormChange}
              showError={showError}
              formData={editAddressData}
              submitForm={handlers.submitAddressForm}
              buttonDisabled={!handlers.checkRequiredInputs()}
              isBusinessAddress={businessAddress}
              handleBusinessAddressChange={actions.businessAddress}
            />
          )}
        </div>
      )}
    </ReturnsSidebar>,
    node,
  );
};
